import "./CookiePolicy.module.css";
import Header from "@/reusable_sections/Header";
import CookiePolicy from "./sections/CookiePolicy";
import CookieCategories from "./sections/CookieCategories";
import UserRightsControls from "./sections/UserRightsControls";
import Footer from "@/reusable_sections/Footer";
export default function CookiePolicyPage() {
  return <div>
      <Header />
      <CookiePolicy />
      <CookieCategories />
      <UserRightsControls />
      <Footer />
    </div>;
}